__turbopack_context__.v({
  "black": "_8TfPva_black",
  "dark": "_8TfPva_dark",
  "default": "_8TfPva_default",
  "light": "_8TfPva_light",
  "status": "_8TfPva_status",
  "tag": "_8TfPva_tag",
});
